import React from 'react';
import { Warning as AllergyIcon } from '@mui/icons-material';
import { Box, useTheme } from '@mui/material';

interface PatientAllergiesIndicatorProps {
  isHovered: boolean;
}

export const PatientAllergiesIndicator: React.FC<PatientAllergiesIndicatorProps> = ({
  isHovered,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '16px',
          border: '1.5px solid',
          borderColor: isHovered ? 'error.main' : 'borderColors.primary',
          bgcolor: isHovered ? 'error.main' : 'backgroundColors.secondary',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.2s ease-in-out',
          transform: isHovered ? 'scale(1.1)' : 'scale(1)',
          '&:hover': {
            bgcolor: 'error.main',
            borderColor: 'error.main',
            transform: 'scale(1.1)',
          },
        }}
      >
        <AllergyIcon
          sx={{
            fontSize: 18,
            color: isHovered ? 'white' : theme.palette.text.secondary,
            transition: 'color 0.2s ease-in-out',
          }}
        />
      </Box>
    </Box>
  );
};

